export default __webpack_public_path__ + "static/media/PS-LOGO-2.b086ef6d.png";